import React from 'react';
import { observer } from 'mobx-react';

import { legendOptions } from './constants';
import { AntSelectWithCustomOptions } from 'controls/react/AntSelectWithCustomOptions';
import { AntSelectProps } from 'controls/react/ant/ant-select/types';

export type LegendSelectProps = AntSelectProps<string[]> & {};

export const MetricLegendSelect = observer((props: LegendSelectProps) => {
	return <AntSelectWithCustomOptions {...props} options={legendOptions} />;
});
